import { all, fork } from "redux-saga/effects";
import DeviceSaga from "./device-saga";
import AuthSaga, { WatchLogin } from "./auth-saga";
import {
  AssetsDownloadSaga as AssetsOldDownloadSaga,
  FetchAssetSaga as FetchOldAssetSaga,
} from "./asset_old-saga";
import {
  FetchAssetSaga,
  FetchAssetsDeviceTypesSaga,
  FetchAssetsDeviceNamesSaga,
  FetchAssetsDeviceProfilesSaga,
  FetchAssetsLocationsSaga,
  //FetchDeviceCountFromGatewaySaga,
  CreateAssetSaga,
  UpdateAssetSaga,
  DeleteAssetSaga,
  DownloadImageSaga,
  FetchAllAssetSagaForMap,
  AssetsDownloadSaga,
  FetchLocationAlertsSaga as FetchLocationAlertsSagaAsset,
  FetchAssetsSingleDeviceTypesSaga,
  FetchDeviceDetailsSaga,
  FetchFloorViewSaga
} from "./asset-saga";
import { UsersDownloadSaga, FetchUserSaga, FetchUsersListSaga, FetchRolesListSaga } from "./user-saga";
import {
  FetchLocationSaga,
  FetchLocationSagaAll,
  LocationDownloadSaga,
  CreateLocationSaga,
  UploadImageSaga,
  DeleteImageSaga,
  FetchImageSaga,
} from "./location-saga";
import {
  FetchOrganizationSaga,
  OrganizationDownloadSaga,
} from "./organization-saga";
import { RolesDownloadSaga, RolesFetchSaga } from "./roles-saga";
import GlobalSearchSaga from "./globalSearch-saga";
import singleDeviceSaga from "./singleDevice-saga";
import {
  AlertDownloadSaga,
  FetchAlertSaga,
  BulkUpdateSaga,
  BulkUpdateFilterSaga,
} from "./alert-saga";

import {
  FetchAlertsGroupSaga,
  CreateAlertsGroupSaga,
  EditAlertsGroupSaga,
  DeleteAlertGroupSaga,
  ExportAlertGroupSaga,
} from "./alerts-group-saga";
import { FetchInsightTab1Saga, FetchInsightTab2Saga } from "./insight-saga";
import { DevicesSaga, DeviceDownloadSaga, FetchDevicesTypesSaga, CreateDeviceSaga } from "./devices-saga";

import { SingleDeviceHeaderSaga } from "./singleDeviceHeader-saga";

import { DeviceMapSaga, HandlePausePlaySaga } from "./deviceMap-saga";

import {
  DeviceDashboardRSSIHistorySaga,
  DeviceDashboardLocationHistorySaga,
  DeviceDashboardBatteryHistorySaga,
  DeviceDashboardAcclerationHistorySaga,
  DeviceDashboardSignalHistorySaga,
  DeviceDashboardGatewayTelemetrySaga,
  DeviceDashboardAssetHistorySaga,
  DeviceDashboardShockAlarmHistorySaga,
} from "./deviceDashboard-saga";

import { DeviceExplorerGraphSaga } from "./deviceExplorer-saga";

import {
  FetchShipmentSaga,
  DeviceDetailsShipmentSaga,
  DownloadShipmentSaga,
  CreateShipmentSaga,
  FetchShipDeviceSaga,
  FetchLocationAlertsSaga,
  FetchShipProfileSaga,
  DeleteShipmentSaga,
  BulkDeleteShipmentSaga,
  FetchShipAlertSaga,
  UpdateShipmentSaga,
  SingleUpdateShipmentStateSaga,
  BulkEditShipmentSaga,
  FetchShipDeviceNameSaga,
  FetchAlertsContentSaga,
  BulkUpdateShipmentStateSaga,
  CancelShipmentSaga,
  BulkCancelShipmentSaga,
  FetchAllShipmentSaga,
} from "./shipment-saga";

import {
  FetchDeviceProfileSaga,
  CreateDeviceProfileSaga,
  UpdateDeviceProfileSaga,
  DeleteDeviceProfileSaga,
  DownloadDeviceProfileSaga,
  DeviceProfileDeviceTypeSaga,
  FetchallAssetSaga,
  FetchallLocationSaga,
  ValidateDeviceProfileSaga
} from "./deviceProfile-saga";

import {
  DeviceShipmentBatteryHistorySaga,
  DeviceShipmentHumiditySaga,
  DeviceShipmentPressureSaga,
  DeviceShipmentRSSIHistorySaga,
  DeviceShipmentSignalHistorySaga,
  DeviceShipmentTemperatureSaga,
  DeviceShipmentLightSaga,
  DeviceShipmentTiltSaga,
  DeviceShipmentShockAlarmHistorySaga,
} from "./deviceShipmentsDashboard-saga";

import {
  FetchAlertShipmentSaga,
  AlertShipmentDownloadSaga,
  BulkShipmentUpdateFilterSaga,
  BulkShipmentUpdateSaga,
} from "./alertShipment-saga";

import { FetchSingleAssetAlertSaga,
   BulkSingleAssetUpdateSaga,
  BulkSingleAssetUpdateFilterSaga,
  AlertSingleAssetDownloadSaga,
 } from "./singleAsset-saga";

export default function* rootSaga() {
  yield all([
    fork(DeviceSaga),
    fork(AuthSaga),
    fork(WatchLogin),
    fork(UsersDownloadSaga),
    fork(FetchUserSaga),
    fork(FetchUsersListSaga),
    fork(FetchRolesListSaga),
    fork(FetchLocationSaga),
    fork(FetchLocationSagaAll),
    fork(LocationDownloadSaga),
    fork(CreateLocationSaga),
    fork(UploadImageSaga),
    fork(DeleteImageSaga),
    fork(FetchImageSaga),
    fork(FetchOrganizationSaga),
    fork(OrganizationDownloadSaga),
    fork(RolesFetchSaga),
    fork(RolesDownloadSaga),
    fork(GlobalSearchSaga),
    fork(singleDeviceSaga),
    fork(FetchAlertSaga),
    fork(FetchAlertShipmentSaga),
    fork(AlertDownloadSaga),
    fork(BulkUpdateSaga),
    fork(BulkUpdateFilterSaga),
    fork(FetchInsightTab1Saga),
    fork(FetchInsightTab2Saga),
    fork(DevicesSaga),
    fork(SingleDeviceHeaderSaga),
    fork(DeviceDownloadSaga),
    fork(DeviceDashboardRSSIHistorySaga),
    fork(DeviceDashboardLocationHistorySaga),
    fork(DeviceDashboardBatteryHistorySaga),
    fork(DeviceDashboardAssetHistorySaga),
    fork(DeviceDashboardAcclerationHistorySaga),
    fork(DeviceDashboardSignalHistorySaga),
    fork(DeviceDashboardGatewayTelemetrySaga),
    fork(DeviceDashboardShockAlarmHistorySaga),
    fork(DeviceShipmentRSSIHistorySaga),
    fork(DeviceShipmentHumiditySaga),
    fork(DeviceShipmentBatteryHistorySaga),
    fork(DeviceShipmentTemperatureSaga),
    fork(DeviceShipmentPressureSaga),
    fork(DeviceShipmentSignalHistorySaga),
    fork(DeviceShipmentLightSaga),
    fork(DeviceShipmentTiltSaga),
    fork(DeviceShipmentShockAlarmHistorySaga),
    fork(DeviceMapSaga),
    fork(HandlePausePlaySaga),
    fork(DeviceExplorerGraphSaga),
    fork(FetchShipmentSaga),
    fork(DownloadShipmentSaga),
    fork(CreateShipmentSaga),
    fork(FetchShipDeviceSaga),
    fork(FetchLocationAlertsSaga),
    fork(FetchShipProfileSaga),
    fork(DeleteShipmentSaga),
    fork(BulkDeleteShipmentSaga),
    fork(CancelShipmentSaga),
    fork(BulkCancelShipmentSaga),
    fork(FetchShipAlertSaga),
    fork(DeviceDetailsShipmentSaga),
    fork(UpdateShipmentSaga),
    fork(SingleUpdateShipmentStateSaga),
    fork(BulkEditShipmentSaga),
    fork(FetchShipDeviceNameSaga),
    fork(FetchAlertsGroupSaga),
    fork(CreateAlertsGroupSaga),
    fork(EditAlertsGroupSaga),
    fork(DeleteAlertGroupSaga),
    fork(ExportAlertGroupSaga),
    fork(FetchAlertsContentSaga),
    fork(DeviceProfileDeviceTypeSaga),
    fork(FetchDeviceProfileSaga),
    fork(CreateDeviceProfileSaga),
    fork(UpdateDeviceProfileSaga),
    fork(DeleteDeviceProfileSaga),
    fork(DownloadDeviceProfileSaga),
    fork(FetchDevicesTypesSaga),
    fork(CreateDeviceSaga),
    fork(AlertShipmentDownloadSaga),
    fork(BulkShipmentUpdateSaga),
    fork(BulkShipmentUpdateFilterSaga),
    fork(BulkUpdateShipmentStateSaga),
    fork(FetchAllShipmentSaga),
    fork(AssetsOldDownloadSaga),
    fork(FetchOldAssetSaga),
    fork(AssetsDownloadSaga),
    fork(FetchAssetSaga),
    fork(FetchLocationAlertsSagaAsset),
    fork(FetchAssetsDeviceTypesSaga),
    fork(FetchAssetsDeviceNamesSaga),
    fork(FetchAssetsSingleDeviceTypesSaga),
    fork(FetchAssetsDeviceProfilesSaga),
    fork(FetchAssetsLocationsSaga),
    //fork(FetchDeviceCountFromGatewaySaga),
    fork(CreateAssetSaga),
    fork(UpdateAssetSaga),
    fork(DeleteAssetSaga),
    fork(FetchallAssetSaga),
    fork(FetchAllAssetSagaForMap),
    fork(FetchSingleAssetAlertSaga),
    fork(BulkSingleAssetUpdateSaga),
    fork(BulkSingleAssetUpdateFilterSaga),
    fork(AlertSingleAssetDownloadSaga),
    fork(FetchallLocationSaga),
    fork(DownloadImageSaga),
    fork(FetchDeviceDetailsSaga),
    fork(FetchFloorViewSaga),
    fork(ValidateDeviceProfileSaga),
  ]);
}
